import axios from "axios";
import type { AppThunk } from "@Store/index";
import {
  updateCategoryBlogs,
  setCategoryBlogsLoading,
  setActiveCategory,
  type BlogPostSimple,
} from "./blogHomeReducer";
import getBlogCollectionUrl, {
  type RegionalBlogLanguage,
} from "@Pages/Blog/utils/getBlogCollectionUrl";
import getBlogImageUrl from "@Pages/Blog/utils/getBlogImageUrl";

interface CategoryBlogResponse {
  id: number;
  name: string;
  slug: string;
  mainImage: {
    id: number;
    alt: string;
    url: string;
    filename?: string;
    mimeType?: string;
    filesize?: number;
    width?: number;
    height?: number;
  };
  category: {
    id: number;
    name: string;
    slug: string;
  };
  date: string;
  updatedAt?: string;
  readTime: string;
}

interface GetBlogsByCategoryParams {
  categorySlug: string;
  categoryName?: string;
  lang?: RegionalBlogLanguage;
}

const getBlogsByCategory =
  ({ categorySlug, categoryName, lang }: GetBlogsByCategoryParams): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setCategoryBlogsLoading(true));
      dispatch(setActiveCategory({ name: categoryName || categorySlug, slug: categorySlug }));

      const apiUrl = `${getBlogCollectionUrl(
        "blog-posts",
        lang,
      )}?where[category.slug][equals]=${categorySlug}&limit=12&select[id]=true&select[name]=true&select[slug]=true&select[mainImage]=true&select[category]=true&select[readTime]=true&select[date]=true&select[updatedAt]=true&where[_status][equals]=published&where[isArchived][equals]=false`;

      const response = await axios.get<{ docs: CategoryBlogResponse[] }>(apiUrl);

      // Transform category blogs
      const categoryBlogs: BlogPostSimple[] = (response.data?.docs || []).map((blog) => ({
        id: blog.id,
        name: blog.name,
        slug: blog.slug,
        mainImage: { ...blog.mainImage, url: getBlogImageUrl(blog.mainImage.url) },
        category: blog.category,
        date: blog.date,
        updatedAt: blog.updatedAt,
        readTime: blog.readTime,
      }));

      dispatch(updateCategoryBlogs(categoryBlogs));
    } catch (error) {
      console.error("Error fetching category blogs:", error);
      dispatch(updateCategoryBlogs([]));
      dispatch(setCategoryBlogsLoading(false));
    }
  };

export default getBlogsByCategory;
